import React, {useEffect, useState} from "react";
import {Alert, Button, Card, Col, Form, Row, Table} from "react-bootstrap";
import 'react-quill/dist/quill.snow.css';
import VenuesService from "../../services/venues.service";
import {
    actDropdownValue,
    actScheduledVenueSlotFilter, isLoggedIn,
    isLoggedInWithRole,
    isLoggedInWithRoleAndUserIs,
    SLOT_DESCRIPTIONS,
    slotActIdMatch
} from "../../common/utils";
import ActsService from "../../services/acts.service";
import {useForm} from "react-hook-form";
import AuthService from "../../services/auth.service";
import {API_EDITS_ALLOWED} from "../../services/axios.utils";
import {Link} from "react-router-dom";

const VenueSlotsEdit = ({venue}) => {
    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors},
    } = useForm()

    let canEdit = isLoggedInWithRoleAndUserIs('host', venue.creator_id);
    let canEditNew = isLoggedInWithRole('host');
    let allowEdit = canEdit || (canEditNew && (venue.id === undefined));

    let user = AuthService.getCurrentUser();
    let loggedIn = isLoggedIn();
    let editsAllowed = API_EDITS_ALLOWED === "true" || (loggedIn && user.is_admin);

    const [matchInfo, setMatchInfo] = useState({});
    const [acts, setActs] = useState([]);

    // object that represents a map of slot_def to availability (true/false)
    const [slotAvailabilities, setSlotAvailabilities] = useState({});

    // object that represents a map of slot_def to scheduled act id
    const [slotScheduledActIds, setSlotScheduledActIds] = useState({});

    const initializeSlotInfo = () => {
        for (let i = 1; i < 5; i++) {
            let sd = "Slot " + i
            slotAvailabilities[sd] = venue.available_slots.some(element => [sd].includes(element.slot_def));
            let slotActId = venue.available_slots.map(s =>
                (s.slot_def === sd && s.scheduled_act !== null ? s.scheduled_act.id : null))
                .filter(a => a !== null);
            slotScheduledActIds[sd] = (slotActId[0] == null ? null : slotActId[0]);
        }
        console.log("init: slotAvailabilities=" + JSON.stringify(slotAvailabilities));
        console.log("init: slotScheduledActIds=" + JSON.stringify(slotScheduledActIds));
    }

    const fetchVenue = () => {
        VenuesService.getVenueById(venue.id).then(
            response => {
                // console.log("venue:" + JSON.stringify(response.data));
                initializeSlotInfo();
                let mi = {}
                for (let i = 1; i < 5; i++) {
                    mi["Slot " + i] = slotActIdMatch(response.data.available_slots, "Slot " + i);
                }
                setMatchInfo(mi);
                console.log("matchInfo: " + JSON.stringify(mi));
                venue = response.data;
            },
            error => {
                console.log(error);
            });
    }

    const fetchActs = () => {
        ActsService.getActs().then(
            response => {
                let acts = response.data.data;
                setActs(acts);
                // console.log("acts:" + JSON.stringify(response.data.data));
                if (venue.id !== undefined) {
                    fetchVenue();
                }
            },
            error => {
                console.log(error);
            });
    }

    useEffect(() => {
        fetchActs();
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    // cannot register venueBio like the other fields because the input type is react-quill
    useEffect(() => {
        register("venueBio", {required: true});
        setValue("venueBio", venue.bio);
    }, [register]);  // eslint-disable-line react-hooks/exhaustive-deps

    const updateSlotAvailability = (slotDef, isAvailable) => {
        // console.log("!!!FIRED!!! - slotDef=" + slotDef + ", isAvailable=" + isAvailable)
        let newAvailability = {};
        for (let i = 1; i < 5; i++) {
            let sd = "Slot " + i;
            if (sd === slotDef) {
                newAvailability[sd] = isAvailable;
            } else {
                newAvailability[sd] = slotAvailabilities[sd];
            }
        }
        console.log("newAvailability=" + JSON.stringify(newAvailability));
        setSlotAvailabilities(newAvailability);
    }

    const updateSlotScheduledActId = (slotDef, actId) => {
        let newScheduledActId = {};
        for (let i = 1; i < 5; i++) {
            let sd = "Slot " + i;
            if (sd === slotDef) {
                if (actId === "--") {
                    newScheduledActId[sd] = null;
                } else {
                    newScheduledActId[sd] = actId;
                }
            } else {
                newScheduledActId[sd] = slotScheduledActIds[sd];
            }
        }
        console.log("newScheduledActId=" + JSON.stringify(newScheduledActId));
        setSlotScheduledActIds(newScheduledActId);
    }

    const handleCancel = (event) => {
        event.preventDefault();
        window.location.assign("/venues");
    }

    // todo: handle backend errors (non-200 or 204)
    // todo: validate address is unique (integrity error)
    const handleSubmitRHF = (data) => {
        console.log("=== data: " + JSON.stringify(data));

        // populate the slots part of the payload
        console.log("on submit - slotAvailabilities=" + JSON.stringify(slotAvailabilities));
        console.log("on submit - slotScheduledActIds=" + JSON.stringify(slotScheduledActIds));

        let slots = []
        // for a new venue
        if (venue.id === undefined) {
            data.venueSlotsAvail.forEach(s => {
                slots.push({"slot_def": s});
            })
        } else {
            for (let index = 1; index < 5; index++) {
                let sd = "Slot " + index;
                if (slotAvailabilities[sd]) {
                    if (slotScheduledActIds[sd]) {
                        slots.push({"slot_def": sd, "scheduled_act_id": slotScheduledActIds[sd]});
                    } else {
                        slots.push({"slot_def": sd});
                    }
                }
            }
        }

        let payload = {
            // address: data.venueAddress,
            // bio: data.venueBio,
            // rain_date_available: data.venueRainDateAvail,
            // preferred_act_types: toStrArray(data.venuePrefGenres),
            available_slots: slots,
            // size_pref: data.venueSizePref,
            // provide_electric: data.venueProvideElectric,
            // provide_sound_system: data.venueProvideSoundSystem,
        }
        console.log("payload: " + JSON.stringify(payload))

        if (venue.id === undefined) {
            VenuesService.createVenue(payload).then(
                response => {
                    console.log("venue:" + JSON.stringify(response.data));
                    // todo: pass redirect url since could be coming from "/myvenues"
                    window.location.assign("/venues");
                },
                error => {
                    console.log(error);
                });

        } else {
            VenuesService.updateVenue(venue.id, payload).then(
                response => {
                    console.log("venue:" + JSON.stringify(response.data));
                    // todo: pass redirect url since could be coming from "/myvenues"
                    window.location.assign("/venues");
                },
                error => {
                    console.log(error);
                });
        }
    }

    return (
        <>
            {!allowEdit &&
                <div>You are not allowed to perform this action.</div>
            }
            {allowEdit &&
                <div>
                    {!editsAllowed &&
                        <Alert variant="danger">
                            Registration is closed for Porchfest 2025. If you need to modify your venue,
                            please <Link to="/contact" reloadDocument="true">contact us</Link>.
                        </Alert>
                    }

                    {/*"handleSubmit" will validate your inputs before invoking "onSubmit"*/}
                    <Form onSubmit={handleSubmit(handleSubmitRHF)}>

                        {/*<Row className="mb-3">*/}
                        {/*    <Col>*/}
                        {/*        <div>Use the form below to make changes to your venue slots:</div>*/}
                        {/*        <div className="text-danger">*/}
                        {/*            <span className="fs-5 text">*</span> Indicates a required question*/}
                        {/*        </div>*/}
                        {/*    </Col>*/}
                        {/*</Row>*/}

                        {/* for an existing venue */}
                        {(venue.id !== undefined && Object.keys(matchInfo).length !== 0) &&
                            <Card>
                                <Card.Body>
                                    <h3 className="mb-3">
                                        Slots
                                    </h3>
                                    <div>
                                        <p>
                                            Use this page to make changes to your time slots.
                                        </p>
                                        <h5><strong>Availability</strong></h5>
                                        <ul>
                                            <li>
                                                Click the checkboxes below to change the availability of time slots for your venue.
                                            </li><br/>
                                            <li>
                                                Checking a time slot "on" will make it <strong>available</strong> for scheduling an act.
                                            </li><br/>
                                            <li>
                                                Checking a time slot "off" will make it <strong>unavailable</strong>.
                                            </li><br/>
                                            <li>
                                                <strong>If you make a time slot unavailable</strong>, any act scheduled for
                                                it will be
                                                removed. Please contact the act owner scheduled for the time slot <span
                                                className="text-decoration-underline">prior</span> to
                                                making it unavailable to let them know you will no longer be hosting them in
                                                that time slot. You can email them directly or send them a contact message
                                                on their act page on this website.
                                            </li>
                                        </ul>

                                        <h5><strong>Scheduled Act</strong></h5>
                                        <ul>
                                            <li>
                                                You can schedule an act in an available time slot by selecting them from
                                                the drop down list next to the slot name.
                                            </li><br/>
                                            <li>
                                                <strong>If you want to add or modify a scheduled act for a time
                                                    slot</strong>, please contact
                                                the act owner <span className="text-decoration-underline">prior</span> to
                                                making changes in order to let them know. You can email them directly or
                                                send them a contact message on their act page on this website.
                                            </li><br/>
                                            <li>
                                                If an act is not available in the list for a time slot, it means that the
                                                act is already scheduled at another venue for this slot.
                                            </li><br/>
                                            <li>
                                                <strong>Certain acts have a preferred venue that they like to perform
                                                    in.</strong> If specified, this is indicated next to their name in the
                                                drop down list. Please don't schedule them in your venue if it is not
                                                their preference. You may contact the act owner by email or via
                                                their act page on this website if you want to discuss it further with them.
                                            </li>
                                        </ul>
                                        <br/>

                                        <Table bordered hover size="lg" responsive>
                                            <thead>
                                            <tr>
                                                <th width="50%">Availability</th>
                                                <th>Scheduled Act</th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            {Array.from({length: 4}).map((_, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Form.Check
                                                            label={"Slot " + (index + 1) + ": " + (SLOT_DESCRIPTIONS["Slot " + (index + 1)]) + (slotAvailabilities["Slot " + (index + 1)] ? " is available" : " is unavailable")}
                                                            {...register("venueSlotsAvail", {required: true})}
                                                            value={"Slot " + (index + 1)}
                                                            defaultChecked={slotAvailabilities["Slot " + (index + 1)]}
                                                            onChange={(e) => {
                                                                updateSlotAvailability("Slot " + (index + 1), e.target.checked);
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Select
                                                            disabled={!slotAvailabilities["Slot " + (index + 1)]}
                                                            hidden={!slotAvailabilities["Slot " + (index + 1)]}
                                                            defaultValue={matchInfo["Slot " + (index + 1)].actId ? matchInfo["Slot " + (index + 1)].actId : "--"}
                                                            onChange={(e) => {
                                                                // console.log(e.target.value);
                                                                updateSlotScheduledActId("Slot " + (index + 1), e.target.value);
                                                            }}
                                                        >
                                                            <option key="--" value="--">--</option>
                                                            {/* filter out acts that have been schedules in the same slot in other venues */}
                                                            {acts.filter(a => actScheduledVenueSlotFilter(a, index+1, venue.id)).map((act) =>
                                                                <option
                                                                    key={act.id}
                                                                    value={act.id}>{actDropdownValue(act)}
                                                                </option>)
                                                            }
                                                        </Form.Select>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </Table>
                                        {errors.venueSlotsAvail &&
                                            <span className="pf-validation-error">At least one slot is required</span>}
                                    </div>
                                </Card.Body>
                            </Card>
                        }

                        <Row className="mb-3">
                            <Col sm={12}>
                                <Button type="submit" disabled={!editsAllowed}>Save</Button>
                                &nbsp;&nbsp;
                                {/*<Link to="/venues">Cancel</Link>*/}
                                <Button type="reset" variant="outline-secondary" onClick={handleCancel}>Cancel</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            }
        </>
    )
};

export default VenueSlotsEdit;
